<template>
  <v-combobox
    ref="combobox"
    v-model="emails"
    :search-input.sync="emailPendente"
    :items="[]"
    :label="label"
    chips
    clearable
    multiple
    :readonly="readonly"
    :rules="regras"
    :error-messages="erroEmailPendente ? [erroEmailPendente] : []"
    @keydown.enter.prevent.stop="commitPendingEmail"
  >
    <template v-slot:selection="{ attrs, item, index, parent, selected }">
      <v-chip
        v-bind="attrs"
        :input-value="selected"
        :close="!readonly"
        @click.stop="editarEmail(parent, index, item)"
        @click:close="removerEmail(item)"
      >
        {{ item }}
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: "FornecedorEmailsField",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Emails *",
    },
  },
  data: () => ({
    emailPendente: "",
    erroEmailPendente: "",
  }),
  computed: {
    emails: {
      get() {
        return this.value;
      },
      set(novaLista) {
        const lista = (novaLista || [])
          .map((email) => String(email || "").trim())
          .filter(Boolean);
        const invalido = lista.find((email) => !this.isEmailValido(email));

        if (invalido) {
          this.emailPendente = invalido;
          this.erroEmailPendente = "Informe um email válido";
        } else {
          this.erroEmailPendente = "";
        }

        this.$emit(
          "input",
          this.removerDuplicados(
            lista.filter((email) => this.isEmailValido(email))
          )
        );
      },
    },
    regras() {
      return [
        (emails) =>
          (emails && emails.length > 0) || "Informe ao menos um email",
        (emails) =>
          (emails || []).every(this.isEmailValido) || "Existe email inválido",
      ];
    },
  },
  methods: {
    isEmailValido(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(String(email || "").trim());
    },
    removerDuplicados(emails) {
      const encontrados = new Set();
      return emails.filter((email) => {
        const chave = email.toLocaleLowerCase();
        if (encontrados.has(chave)) {
          return false;
        }
        encontrados.add(chave);
        return true;
      });
    },
    commitPendingEmail() {
      const email = String(this.emailPendente || "").trim();
      if (!email) {
        this.erroEmailPendente = "";
        return true;
      }

      if (!this.isEmailValido(email)) {
        this.erroEmailPendente = "Informe um email válido";
        this.$nextTick(() => this.$refs.combobox.validate());
        return false;
      }

      const indiceEdicao = this.$refs.combobox.editingIndex;
      if (indiceEdicao > -1) {
        const emailsAtualizados = [...this.value];
        emailsAtualizados.splice(indiceEdicao, 1, email);
        this.emails = emailsAtualizados;
        this.$refs.combobox.editingIndex = -1;
      } else {
        this.emails = [...this.value, email];
      }

      this.emailPendente = "";
      this.erroEmailPendente = "";
      return true;
    },
    removerEmail(email) {
      if (this.readonly) {
        return;
      }

      const chave = String(email).trim().toLocaleLowerCase();
      const indice = this.value.findIndex(
        (item) => String(item).trim().toLocaleLowerCase() === chave
      );
      if (this.$refs.combobox.editingIndex === indice) {
        this.$refs.combobox.editingIndex = -1;
        this.emailPendente = "";
      } else if (this.$refs.combobox.editingIndex > indice) {
        this.$refs.combobox.editingIndex -= 1;
      }

      this.emails = this.value.filter(
        (item) => String(item).trim().toLocaleLowerCase() !== chave
      );
    },
    editarEmail(combobox, index, email) {
      if (this.readonly) {
        return;
      }

      combobox.editingIndex = index;
      combobox.selectedIndex = -1;
      combobox.internalSearch = String(email).trim();
      this.erroEmailPendente = "";
      this.$nextTick(() => combobox.focus());
    },
  },
};
</script>
